// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getImageCss, productImageCarouselStyles } from "@stanion/Overrides/Components/ProductImageCarousel";
import { color, xScreen } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

productImageCarouselStyles.mainContainer = {
    gap: 0,
    css: css`
        position: relative;
        &&& {
            max-width: 317px;
        }
        ${xScreen("lte", "xs")} {
            &&& {
                max-width: 100%;
            }
        }
    `,
};

productImageCarouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 0;
        position: absolute;
        left: -4px;
        top: 18px;
        &:hover {
            &&&& {
                background-color: transparent;
                svg {
                    color: ${color("common.ui10")};
                }
            }
        }
    `,
};

productImageCarouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        text-align: center;
        position: relative;
        padding: 16px 8px 2px;
        display: flex;
        justify-content: center;
    `,
};

productImageCarouselStyles.image = {
    css: css`
        ${getImageCss("common.border")}
        opacity: 0.5;
    `,
};

productImageCarouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        position: absolute;
        right: -4px;
        top: 18px;
        ${xScreen("lte", "xs")} {
            right: 0;
        }
        border: 0;
        padding: 0;
        &:hover {
            &&&& {
                background-color: transparent;
                svg {
                    color: ${color("common.ui10")};
                }
            }
        }
    `,
};

productImageCarouselStyles.slide = {
    css: css`
        flex: 0 0 52px;            
    `,
};
